import type React from "react";

export const GolfIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 542.59 542.59"
      {...restProps}
    >
      <title>Golf Icon</title>
      <g>
        <path
          d="M253.851 124.664c0-22.109-18.178-40.039-40.631-40.039-22.424 0-40.603 17.92-40.603 40.039 0 22.232 18.178 40.22 40.603 40.22 22.414-.001 40.631-17.988 40.631-40.22z"
          fill={color}
        />
        <path
          d="M419.321 163.87c-1.588-8.587-8.635-13.521-9.056-13.895L187.554 3.191c-8.816-5.805-20.827-3.471-26.833 5.221l-11.274 16.352c-4.198 6.407-2.362 14.736 3.959 18.886 6.359 4.208 13.33 1.042 17.423-5.374l8.597-21.181 199.608 131.972-158.767 28.668c-11.284 1.817-19.393 13.101-16.878 24.078l34.54 133.655-111.7 167.593c-6.742 11.437-2.668 26.182 8.903 32.704 11.695 6.646 26.431 2.562 33.163-8.865 0 0 116.567-175.271 117.007-176.466l6.072 24.489-17.604 139.823c-2.171 13.015 6.761 25.302 20.005 27.502 13.205 2.218 25.675-6.627 27.922-19.642l18.055-143.505c.573-3.461-.144-11.073-.976-14.344l-39.79-158.422 103.667-18.666c11.113-1.959 18.58-12.63 16.668-23.799z"
          fill={color}
        />
      </g>
    </svg>
  );
};
